import {
  TextField,
  InputAdornment,
  Typography,
  Grid,
  makeStyles,
} from "@material-ui/core";
import { formatNumberToMonetary } from "../../../utils";
import { lang } from "../../../i18nLang";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#EEEEEE",
    border: "1px solid #ABAAAC",
    margin: 0,
    padding: "0.5rem 1rem",
    textAlign: "right",
    borderRadius: 4,
  },
  label: {
    fontSize: "0.8rem",
    fontWeight: 400,
    lineHeight: 1,
    color: "#727272 !important",
    textTransform: "initial",
    letterSpacing: 0,
  },
  input: {
    justifyContent: "center",
    "& .MuiInputBase-root": {
      maxWidth: 160,
      margin: "0px !important",
      "& > .MuiInputBase-input": {
        textAlign: "right",
        padding: 0,
      },
      "& > .MuiInputAdornment-root > p": {
        fontWeight: 700,
        color: theme.palette.gray[800],
      },
      "&.Mui-focused > .MuiOutlinedInput-notchedOutline": {
        borderColor: "#000",
        borderWidth: 1,
      },
    },
  },
}));

interface IProps {
  /** Rótulo do card. */
  label: string;
  /** Valor do campo. Deve ser um valor númerico válido, pois este será formatado com a máscara "#0,00" para ser exibido no card. */
  value: number;
  /** Margin personalizada do campo, que pode ser passada como um único valor, um array com dois valores ou um array com quatro valores.
   * Só serão aceitos valores númericos que serão multiplicados por 0.25rem.  */
  margin: number | number[];
}

const MonetaryCard = ({ label, value, margin = [0, 0.5] }: IProps) => {
  const classes = useStyles();

  let newStyle = {
    margin: Array.isArray(margin)
      ? margin
          .slice(0, 4)
          .map((val) => `${val}rem`)
          .join(" ")
      : `${margin}rem`,
  };

  return (
    <Grid className={classes.root} style={newStyle}>
      <Typography className={classes.label}>{label}</Typography>
      <TextField
        className={classes.input}
        value={formatNumberToMonetary(value, false)}
        type="text"
        size="small"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">{lang("currency")}</InputAdornment>
          ),
          readOnly: true,
          disableUnderline: true,
        }}
      />
    </Grid>
  );
};

export default MonetaryCard;
